import { useMediaQuery } from "usehooks-ts";

// https://tailwindcss.com/docs/screens
export default function useFixedRangeTailwindBreakpoints() {
  const small = useMediaQuery("(min-width: 640px and max-width: 767px)");
  const medium = useMediaQuery("(min-width: 768px and max-width: 1023px)");
  const large = useMediaQuery("(min-width: 1024px and max-width: 1279px)");
  const extraLarge = useMediaQuery("(min-width: 1280px and max-width: 1535px)");

  return {
    sm: small,
    md: medium,
    lg: large,
    xl: extraLarge,
  };
}

export function useMinWidthTailwindBreakpoints() {
  const small = useMediaQuery("(min-width: 640px)");
  const medium = useMediaQuery("(min-width: 768px)");
  const large = useMediaQuery("(min-width: 1024px)");
  const extraLarge = useMediaQuery("(min-width: 1280px)");

  return {
    sm: small,
    md: medium,
    lg: large,
    xl: extraLarge,
  };
}

export function useMaxWidthTailwindBreakpoints() {
  const small = useMediaQuery("(max-width: 639px)");
  const medium = useMediaQuery("(max-width: 767px)");
  const large = useMediaQuery("(max-width: 1023px)");
  const extraLarge = useMediaQuery("(max-width: 1279px)");

  return {
    sm: small,
    md: medium,
    lg: large,
    xl: extraLarge,
  };
}
